import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M809-56 653-212q-20 13-39 21.5T574-175v-63q9-3 18-7.5t18-9.5L256-609q-19 31-27.5 65.5T220-477q0 58 21.5 105.5T307-287l30 21v-124h60v230H167v-60h130l-15-12q-68-54-95.5-115T160-477q1-54 15-97t38-78L57-808l41-41L850-97l-41 41Zm-72-236-42-42q21-33 33-70t12-79q0-46-22.5-95.5T655-668l-29-26v124h-60v-230h230v60H665l15 14q64 60 92 124t28 119q0 54-15.5 101T737-292ZM334-695l-41-41q22-17 45.5-28.5T387-784v62q-13 5-26.5 12T334-695Z"
  })
}), "SyncDisabledFilled");